export default __webpack_public_path__ + "static/media/industrial.3a92ad20.png";